
import { mapActions, mapState } from 'vuex';
import promiseErrors from '~/services/promiseErrors';

export default {
    name: 'Profile',
    async asyncData({ app, error, route }) {
        const userParam = route.params.user ? `/${route.params.user}` : '';
        const [user, groups, events] = await promiseErrors(
            [
                app.$axios.$get(`${app.$config.endpoints.user}${userParam}`),
                app.$axios.$get(`${app.$config.endpoints.group}`, { params: { per_page: 3, user: route.params.user } }),
                app.$axios.$get(`${app.$config.endpoints.event}`, { params: { per_page: 3, user: route.params.user } }),
            ],
            app,
        );

        if (!user) {
            return error({ statusCode: 404, message: app.i18n.t('profile.not_found') });
        }

        return {
            user: user ? user.user : {},
            groups: groups ? groups.groups.data : {},
            events: events ? events.events.data : {},
        };
    },
    data() {
        return {
            reportableEndpoint: `${this.$config.endpoints.user}/${this.$route.params.user}/report`,
            groups: {},
            events: {},
            jobs: [],
            user: {},
        };
    },
    head() {
        let username = this.user.first_name;
        if (this.user.last_name) {
            username = `${this.user.first_name} ${this.user.last_name}`;
        }
        return {
            title: `${this.$t('metadata.profileuser.text', { username })} - ClearWaste`,
        };
    },
    computed: {
        ...mapState(['auth']),
        isSelf() {
            return !this.$route.params.user || (this.auth.user && this.auth.user.slug && this.$route.params.user === this.auth.user.slug);
        },
        showJobs() {
            return this.auth.user && (this.auth.user.role === 'admin' || this.auth.user.role === 'moderator');
        },
    },
    created() {
        if (Object.keys(this.user).length === 0) {
            this.$router.push({ name: 'dashboard' });
        }
        this.getJobs();
    },
    methods: {
        ...mapActions(['showReportable']),
        async getJobs() {
            if (!this.showJobs) {
                return;
            }
            const jobs = await this.$axios.$get(this.$config.endpoints.job, { params: { user_id: this.user.id } });
            this.jobs = jobs.jobs.data;
        },
        confirmDelete() {
            this.$store.dispatch('showConfirm', {
                callback: this.deleteAvatar,
                text: this.$t('account.confirm_delete_users_profile_picture'),
            });
        },
        async deleteAvatar() {
            const userParam = `/${this.$route.params.user}`;
            const { message } = await this.$axios.$put(`${this.$config.endpoints.user}${userParam}`, {
                image_id: null,
            });
            this.$store.dispatch('setFlashMessage', { message });
            const { user } = await this.$axios.$get(`${this.$config.endpoints.user}${userParam}`);
            this.user = user;
        },
    },
};
